var LogTransacaoEnum = {
  286: 'NOVA_TAREFA',
  287: 'ALTERAR_TAREFA',
  288: 'NOVA_OCORRENCIA_TAREFA',
  289: 'ASSUMIR_TAREFA',
  290: 'REABRIR_TAREFA',
  291: 'CONSULTA_TAREFA'
}

export default LogTransacaoEnum



// WEBPACK FOOTER //
// ./client/enum/logTransacao.js